import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const supportService = {
  sendRequest,
  registeredSendRequest,
  errorReport,
  personalTariffPlanOrderSend
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'Support'
};

function extract(r) {
  return r.data;
}

async function sendRequest(
  emailFrom: string,
  phoneFrom: string,
  head: string,
  body: string,
  token: string,
  files: [],
  recaptchaType: string) {
  return axios
    .put(`${model.baseUrl}${model.controller}/SendMessage`,
      { emailFrom, phoneFrom, head, body, googleReCaptchaResponse: token, files, recaptchaType })
    .then(extract);
}

async function registeredSendRequest(head: string, body: string, files: []) {
  return axios
    .put(`${model.baseUrl}${model.controller}/RegisteredSendMessage`, { head, body, files })
    .then(extract);
}

async function errorReport(head: string, body: string, error: string, files: []) {
  return axios
    .put(`${model.baseUrl}${model.controller}/ErrorReport`, { head, body, error, files })
    .then(extract);
}

async function personalTariffPlanOrderSend({
  organizationName, organizationEmail, organizationPhone,
  contactPersonName, contactPersonEmail, contactPersonPhone,
  documentsPerMonth, commentary
}) {
  return axios
    .post(`${model.baseUrl}${model.controller}/PersonalTariffPlanOrderSend`,
      {
        organizationName,
        organizationEmail,
        organizationPhone,
        contactPersonName,
        contactPersonEmail,
        contactPersonPhone,
        documentsPerMonth,
        commentary
      })
    .then(extract);
}
